"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDomEvent = void 0;
const react_1 = require("react");
const useDomEvent = (element, eventNames, handler, deps = []) => {
    (0, react_1.useEffect)(() => {
        for (const eventName of eventNames) {
            element.addEventListener(eventName, handler);
        }
        return () => {
            for (const eventName of eventNames) {
                element.removeEventListener(eventName, handler);
            }
        };
    }, deps);
};
exports.useDomEvent = useDomEvent;
